const log = (message: string): void => {
	// development
	// if (!process.env.core_db_socket_path) {
	console.log(`[LOG] ${message}`)
	// }
}

export default log
